module.exports = __webpack_public_path__ + "img/9791130619903.eff8ff9d.jpg";